<style lang="less" scoped>
  @import './index.less';
</style>
<template>
  <div style="width:1100px;margin:0 auto;overflow-x:auto;">
    <div class="member-info-container">
      <svg-icon class="member-icon" icon-class="member" />
      <div class="member-info">
        <div class="member-email">
          <span class="member-account">账号: {{currentUser.name}}</span>
          <div>
             <span class="cur-activity">当前登录: {{activity.activityName || ''}}</span>
            <el-dropdown trigger='click' placement='bottom-end'>
                <span class="el-dropdown-link" style="cursor: pointer; color: #1890ff;">
                  切换活动
                  <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item 
                    v-for="(item, index) in activityList" 
                    :key="index" 
                    @click.native="selectActivity(item)" 
                    :style="{color: activityId == item.id ? '#1890ff' : ''}">
                    {{item.activityName}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
          </div>
        </div>
        <div class="member-address">
          <router-link :to="{ name: 'member-member-address'}">
            我的收货地址
          </router-link>
          <el-button type="text" @click="handleLogout">退出</el-button>
        </div>
      </div>
    </div>
    <div class="member-orders">
      <el-tabs value="member-orders" v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="全部订单" name="allOrders" :lazy="true">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无此类型订单</div>
          <OrderListItem v-else @cancelOrder="cancelOrder" v-for="(order, index) of collection" :key="index" :order="order" @getOrders="listGetOrders"/>
        </el-tab-pane>
        <el-tab-pane label="待付款" :lazy="true" name="unpaidOrders">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无此类型订单</div>
          <OrderListItem v-else  v-for="(order, index) of collection" :key="index"  @cancelOrder="cancelOrder" :order="order" @getOrders="listGetOrders" />
        </el-tab-pane>
        <el-tab-pane label="待收货" :lazy="true" name="unshippingOrders">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无此类型订单</div>
          <OrderListItem v-else v-for="(order, index) of collection" :key="index"  :order="order" @getOrders="listGetOrders" />
        </el-tab-pane>
        <el-tab-pane label="退款单" :lazy="true" name="refundOrders">
          <div v-if="!collection || !collection.length" style="height:500px;" class="flex flex-all-center text-lg">暂无退款单</div>
          <OrderListItem v-else v-for="(order, index) of collection" :key="index" :isRefund="true"  :order="order" @getOrders="listGetOrders" />
        </el-tab-pane>
      </el-tabs>
      <div class="pagination">
        <pagination :total="total" :pagination="pagination" :changed="getOrders" />
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash';
  import OrderListItem from "./components/OrderListItem";

  const { mapState: authMapState } = createNamespacedHelpers('auth')
  const { mapGetters } = createNamespacedHelpers('orders')
    const { mapState: activityMapState } = createNamespacedHelpers('activity')

  const limit = 6

  export default {
    name: 'index',
    components: {OrderListItem},
    data() {
      return {
        activeName: 'allOrders',
      }
    },
    updated() {
    },
    methods: {
      async selectActivity(item) {
        await this.$store.dispatch('activity/setId', item.id)
        console.log('212112');
        this.$router.go(0)
      },
      listGetOrders() {
        const currentPage = this.pagination.currentPage
        this.getOrders({ pagination: { currentPage, limit } })
      },
      cancelOrder() {
        const currentPage = this.pagination.currentPage
        this.getOrders({ pagination: { currentPage, limit } })
      },
      tabClick(tab, event) {
        localStorage.removeItem('currentPage')
        localStorage.removeItem('limit')
        localStorage.setItem('activeTabName', tab.name)
        this.activeName = tab.name
        this.getOrders()
      },
      handleLogout() {
        this.$store.dispatch('auth/logout')
        ysf('logoff')
        this.$router.replace({ name: 'login' })
      },
      async getOrders({ pagination = {limit} } = {}) {
        let query = {};
        switch (this.activeName) {
          case 'unpaidOrders':
            query.orderStatus = this.$enums.orderStatus.UNSETTLED
            query.payStatus = 110
            query.shippingStatus = this.$enums.shippingStatus.UNSHIPPED
            break;
          case 'unshippingOrders':
            query.payStatus = this.$enums.payStatus.PAID
            query.shippingStatus = this.$enums.shippingStatus.UNSHIPPED
            break;
          case 'refundOrders':
            await this.$store.dispatch('orders/loadRefundOrders', { pagination });
            return
          default:
            break;
        }

        const sort = {id: 'desc'}

        await this.$store.dispatch('orders/collection', {query, pagination, sort});
      },
      back() {
        const currentPage = localStorage.getItem('currentPage') ? localStorage.getItem('currentPage') : 0
        const limit = localStorage.getItem('limit') ? localStorage.getItem('limit') : 0
        const activeTabName = localStorage.getItem('activeTabName') ? localStorage.getItem('activeTabName') : 'allOrders'
        this.activeName = activeTabName
        this.getOrders({ pagination: { currentPage, limit } })
      }
    },
    async mounted() {
      await this.getOrders()
      this.$store.dispatch('auth/queryActivity', {account: this.currentUser.account})
      window.addEventListener('load', this.back)
    },
    beforeDestroy() {
      localStorage.removeItem('currentPage')
      localStorage.removeItem('limit')
      localStorage.removeItem('activeTabName')
    },
    computed : {
      ...authMapState([
        'currentUser','activityList'
      ]),

      ...mapGetters([
        'collection',
        'total',
        'pagination']
      ),
      ...activityMapState([
        'activityId', 'activity'
      ])
    },
    watch : {

    }
  };
</script>


